<template>
  <div class="mapping-dashboard">
    <nav class="breadcrumb mt-5" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/">Data Mapping Settings</router-link></li>
      </ul>
    </nav>
    <section class="is-primary mt-5">
      <div>
        <div class="container">
          <h1 class="title">Mapping Cockpit</h1>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="columns is-multiline is-centered">
          <div class="column is-one-quarter" v-for="(option, index) in settingsOptions" :key="index">
            <router-link :to="option.route">
              <div class="card option-card">
                <div class="card-content has-text-centered">
                  <font-awesome-icon :icon="option.icon" class="icon is-large mb-3" style="font-size: 2rem; color: #3273dc;"></font-awesome-icon>
                  <p class="title is-5">{{ option.name }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faSitemap } from '@fortawesome/free-solid-svg-icons';

library.add(faCheckCircle, faSitemap);

export default {
  name: 'MappingDashboard',
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      settingsOptions: [
        { name: 'Validation Rules', route: '/data-mapping/validation-rules', icon: 'check-circle' },
        { name: 'Mapping Rules', route: '/data-mapping/mapping-rules', icon: 'sitemap' }
      ],
    };
  },
};
</script>

<style scoped>
.admin-dashboard {
  text-align: center;
}

.card {
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-10px);
}

.option-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px; /* Set a fixed height for uniform size */
  width: 100%; /* Ensure the card takes full width of the column */
}

.option-card .card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
